import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { TransitionMixin } from '../../helpers';

const BrandedModalContainer = styled(motion.div)`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 6000;
    background-color: #f2f0eb;
    display: flex;
    justify-content: center;
    align-items: center;
    .title-container {
        text-align: center;
        margin-bottom: 40px;

        h2 {
            font-size: 3rem;
            color: #000;
            font-family: neue-kabel, sans-serif;
            font-weight: 800;
            margin: 0 0 30px;
        }

        p {
            font-size: 1rem;
            font-weight: 400;
            max-width: 950px;
            margin: 0 auto;
            line-height: 1.5;
        }
    }

    .options-container {
        display: flex;
        justify-content: center;
        max-width: 600px;
        margin: 0 auto;
        .btn-container {
            flex: 1;
            text-align: center;
            button {
                max-width: 300px;
                width: 100%;
                margin: 0 auto;
                padding: 15px 0;
                font-weight: bold;
                background-color: #f74c34;
                color: #fff;
                border: 1px solid #f74c34;
                border-radius: 5px;
                ${TransitionMixin('.25s')};

                &:hover {
                    background-color: #fff;
                    color: #f74c34;
                }
            }

            &:first-child {
                margin-right: 20px;
            }
        }
    }
`;

const BrandedModal = ({ startFresh, resumeProgress }) => {
    return (
        <BrandedModalContainer
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
                open: { opacity: 1 },
                collapsed: { opacity: 0 },
            }}
            transition={{
                duration: 0.5,
            }}
        >
            <div className="modal-content">
                <div className="title-container">
                    <h2>Hey there 👋</h2>
                    <p>
                        We noticed you've been here before. Would you like to
                        pick up where you left off, or start fresh?
                    </p>
                </div>

                <div className="options-container">
                    <div className="btn-container">
                        <button onClick={() => resumeProgress()}>
                            Keep going
                        </button>
                    </div>
                    <div className="btn-container">
                        <button onClick={() => startFresh()}>
                            Start Fresh
                        </button>
                    </div>
                </div>
            </div>
        </BrandedModalContainer>
    );
};

export default BrandedModal;
